<template>
  <v-list-item
    :ripple="false"
    inactive
    dense
    style="padding: 0; cursor: default"
  >
    <v-list-item-action>
      <v-checkbox
        v-model="widget.isShow"
        :disabled="widget.canShowHide != 'true'"
        @change="check($event)"
      ></v-checkbox>
    </v-list-item-action>
    <v-list-item-content @click="check(!widget.isShow)" class="cursor-pointer">
      <v-list-item-title>{{ getTitle(widget) }} </v-list-item-title>
    </v-list-item-content>

    <v-list-item-action
      v-if="
        $security.checkUserAccess('UpdateDashboard') &&
        widget.isDynamicContent != '1'
      "
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            class="ml-2"
            x-small
            color="secondary"
            elevation="1"
            width="24"
            min-width="24"
            @click="updateWidgetDialog = true"
          >
            <v-icon size="16" color="#999999"> mdi-pencil </v-icon>
          </a-btn>
        </template>
        <span>{{ $t("widget.tipUpdateWidget") }}</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-action v-if="$security.checkUserAccess('DeleteDashboard')">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            class="ml-2"
            x-small
            color="primaryDark"
            elevation="1"
            width="24"
            min-width="24"
            @click="deleteWidget"
          >
            <v-icon size="16"> mdi-delete </v-icon>
          </a-btn>
        </template>
        <span>{{ $t("widget.tipDeleteWidget") }}</span>
      </v-tooltip>
    </v-list-item-action>
    <create-widget
      :widget="widget"
      v-if="updateWidgetDialog"
      v-model="updateWidgetDialog"
      @close="closeCreateWidget"
      @alert="onAlertMessage"
      :preconfigured="preconfigured"
    ></create-widget>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </v-list-item>
</template>

<script>
import widgetService from "/src/api/widgetService";
import { mapActions } from "vuex";
import CreateWidget from "/src/components/widget/CreateWidget.vue";
import MessageSheet from "../MessageSheet.vue";
import ConfirmDialog from "../ConfirmDialog.vue";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
export default {
  name: "WidgetList",
  props: {
    widget: Object,
    preconfigured: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CreateWidget,
    MessageSheet,
    ConfirmDialog,
    ADialog,
    ABtn,
  },
  data() {
    return {
      displayMessage: false,
      messageType: "",
      message: "",
      updateWidgetDialog: false,
      canShowHide: this.widget.isShow,
    };
  },
  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions({
      getPanelWidgetApi: "widget/getPanelWidgets",
      widgetToggleApi: "widget/widgetToggle",
      removePanel: "widget/removePanel",
    }),
    getTitle(widget) {
      if (Number(widget.isDynamicContent) === 1) {
        return this.$t(`widget.${widget.widgetType}`);
      } else {
        return widget.title;
      }
    },
    check(value) {
      if (this.widget.canShowHide !== "true") {
        return;
      }
      this.$emit("overlay", true);
      const data = { id: this.widget.id, isShow: value };
      this.widgetToggleApi(data);
      this.$eventHub.$emit("onDisableWidget", data);
    },

    async deleteWidget() {
      if (
        await this.$refs.confirm.open(
          this.$t("lblConfirmRemoval"),
          this.$t("msgConfirmRemoval") + " " + this.widget.title + "?",
          { yesNoButtons: true }
        )
      ) {
        try {
          await widgetService.deleteWidget(this.widget.id);
          this.$emit("alert", this.$t("widget.msgWidgetDelete"), "success");
          this.removePanel(this.widget.id);
          const proxy = this;
          proxy.$eventHub.$emit("onDeleteWidget", this.widget.id);
        } catch (err) {
          console.log(err);
        }
      }
    },

    closeCreateWidget() {
      this.updateWidgetDialog = false;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    onAlertMessage: function (message, MessageType) {
      this.showMessageSheet(message, MessageType);
    },
  },
};
</script>

<style scope>
.cursor-pointer {
  cursor: pointer;
}
</style>
